module.exports = __webpack_public_path__ + "static/img/20005 (3).e47ceb3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20005 (3).webp
// module id = HOiT
// module chunks = 14